import React from 'react';

export default function SimplePage({
  children,
}: {
  children?: React.ReactNode;
}) {
  return <main className="container mx-auto px-4 pb-16 pt-4">{children}</main>;
}
